import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for TeamMember
 *
 */

const TeamMember = lazyLoad(
  () => import('app/modules/TeamMember'),
  (module) => module.default,
);

export default TeamMember;
